import { render, staticRenderFns } from "./SeriesManager.vue?vue&type=template&id=630e4b0e&scoped=true&"
import script from "./SeriesManager.vue?vue&type=script&lang=js&"
export * from "./SeriesManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630e4b0e",
  null
  
)

export default component.exports